import type { InternalUserAuthenticated } from '@ricoh/ria.client.core/model';

import { createSelector } from '@reduxjs/toolkit';
import { ClientError } from '@ricoh/ria.client.core/errors';
import { isType } from '@ricoh/ria.client.core/utils/data/object';

import type { InternalAuthenticatedUserWithProfile } from './_selector.type';
import type { InternalState } from './_state.type';

/** Internal Selector. */
export const internalSelector = {
  internal_getInternalAuthenticatedUser: createSelector(
    (state: InternalState) => state.internal.user,
    (state: InternalState) => state.internal.profile,

    (user, profile): InternalAuthenticatedUserWithProfile => {
      if (!isType<InternalUserAuthenticated>(user, 'user')) {
        throw new ClientError({
          module: 'store',
          message: 'User is not authenticated',
          cause: user,
        });
      }

      if (!profile) {
        throw new ClientError({
          module: 'store',
          message: 'User profile is not found',
          cause: user,
        });
      }

      return {
        ...user,
        profile,
      };
    },
  ),
};
